import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { StylistValue } from "../../../services/api/instances/stylistApi/stylistTypes";
import { getFilteredObjects } from "../../../shared/utils/objectStorageFunctions";
import { sortAssistantData } from "../../../shared/utils/sortAssistants";
import {
  createStylistAction,
  createStylistThreadAction,
  deleteStylistAction,
  getStylistAssistantsAction,
  getStylistMessagesAction,
  getStylistsAction,
  postStylistMessageAction,
} from "./actions";
import type { StylistState } from "./types";
import { extractAllAssistants } from "../../../shared/utils/extractAllAssistants";

export function getAssistantsReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(getStylistAssistantsAction.fulfilled, (state, action) => {
    const assistants = extractAllAssistants(action.payload);
    state.assistants = sortAssistantData(assistants.data);
  });
}

export function getStylistThreadReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(createStylistThreadAction.fulfilled, (state, action) => {
    state.thread = action.payload;
  });
}

export function getAllStylistsReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(getStylistsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getStylistsAction.fulfilled, (state, action) => {
    state.isLoading = false;
    state.stylists = getFilteredObjects<StylistValue>(action.payload);
  });
  builder.addCase(getStylistsAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export const createStylistReducerBuilder = (
  builder: ActionReducerMapBuilder<StylistState>,
) => {
  builder.addCase(createStylistAction.fulfilled, (state, action) => {
    state.stylists = [...state.stylists, action.payload];
    state.selectedStylist = action.payload;
  });
};

export function deleteStylistReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(deleteStylistAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(deleteStylistAction.fulfilled, (state) => {
    state.isLoading = false;
  });
  builder.addCase(deleteStylistAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function postStylistMessageReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(postStylistMessageAction.fulfilled, (state, action) => {
    state.messages = state.messages.map((item, index) => {
      if (state.messages.length - 1 === index) {
        return action.payload;
      } else {
        return item;
      }
    });
  });
}

export function getStylistMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<StylistState>,
) {
  builder.addCase(getStylistMessagesAction.fulfilled, (state, action) => {
    state.messages = action.payload.data;
  });
}
